export default __webpack_public_path__ + "static/media/ripples.4ac5e894.svg";